module.exports = __webpack_public_path__ + "static/media/suzette_mcnaught.87384097.pdf";